import { createAction } from '@reduxjs/toolkit';
import { GenericAxiosResponse } from 'axios';
import { MassOperationRequest } from '../../utils/restApplicationClient';
import { JobsActionTypes } from './jobs.actions.types';

export const performOperation = createAction<MassOperationRequest>(JobsActionTypes.PerformOperation);

export const performOperationError = createAction(JobsActionTypes.PerformOperationError);

export const performOperationSuccess = createAction(JobsActionTypes.PerformOperationSuccess);

export const getSimilarOperationIds = createAction<MassOperationRequest>(JobsActionTypes.GetSimilarOperationIds);

export const getSimilarOperationIdsSuccess = createAction<GenericAxiosResponse<string[]>>(
  JobsActionTypes.GetSimilarOperationIdsSuccess,
);

export const getSimilarOperationIdsError = createAction(JobsActionTypes.GetSimilarOperationIdsError);
